import { Box, useMediaQuery } from "@mui/material";
import { setLibraryRecentSearch } from "components/app/App.slice";
import { filterPage } from "components/common/Filters/FiltersHelper";
import GlobalFilterDescription from "components/common/Filters/GlobalFilterDescription";
import GlobalFilters from "components/common/Filters/GlobalFilters";
import { setPageFilter } from "components/common/Filters/GlobalFilters.slice";
import Typography from "components/common/Typography";
import { fetchPlansAsync } from "components/common/plans/plans.slice";
import SearchAppBar from "components/common/searchBar";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { PAGE_SIZE, allPlansType, minSearchStrLength } from "utils/CommonConstants";
import { formFilterRequestPayload } from "utils/CommonFunctions";
import { theme as MUITheme } from "../../../styles/Theme";
import Plans from "../../common/plans/plans.layout";
import FunctionalAreasList from "./FunctionalAreasList";
import SuggestedPlans from "./SuggestedPlans";
import { fetchSuggestedPlansIdAsync } from "./SuggestedPlans/SuggestedPlans.slice";

function LibraryHall() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [pageNo, setPageNo] = useState(1);

  const plansList: any = useAppSelector((state) => state.plans.list);
  const totalRecords: any = useAppSelector((state) => state.plans.totalRecords);
  const innCode = useAppSelector((state: any) => state.app.innCode);
  const bookMarkInncodes = useAppSelector((state) => state.Dashboard.bookMarkInncodes);
  const isMobileScreen = useMediaQuery(MUITheme.breakpoints.down("md"));
  const suggestedPlanIds: any = useAppSelector((state) => state.suggestedPlans.listIds);
  const { isAbovePropertyUser, isCorp } = useAppSelector((state) => state.app.loggedInUserDetails);
  const globalFiltersforPage = useAppSelector((state) => state.globalFilters[filterPage.libraryAllPlansDisplay]);
  const filterRequestPayload = globalFiltersforPage?.modifiedFilter || globalFiltersforPage?.defaultFilter || [];
  const formattedFilterRequestPayload = formFilterRequestPayload(filterRequestPayload);
  const libraryRecentSearch = useAppSelector((state) => state.app.libraryRecentSearch);
  const showSuggested = !isCorp && !isAbovePropertyUser;
  const showAllPlans = location.state?.showAllPlans ?? true;
  const getProps = (page?: number) => {
    return {
      filter: {
        innCode,
        ...formattedFilterRequestPayload
      },
      pagination: {
        page: page ?? pageNo + 1,
        size: PAGE_SIZE
      },
      planType:
        formattedFilterRequestPayload["planType"]?.length > 0
          ? formattedFilterRequestPayload["planType"]
          : [allPlansType]
    };
  };

  const getSuggestedProps = () => {
    return {
      filtersRequest: { ...formattedFilterRequestPayload }
    };
  };

  const getSuggestedPlansIds = () => {
    let payload = {};
    if (location?.state?.payload) {
      payload = {
        ...location?.state?.payload
      };
    }
    dispatch(fetchSuggestedPlansIdAsync({ innCode, payload: payload }));
  };

  useEffect(() => {
    const props: any = getProps(1);
    if (showAllPlans) dispatch(fetchPlansAsync(props));
    setPageNo(1);
    showSuggested && getSuggestedPlansIds();
  }, [innCode, isCorp, bookMarkInncodes, filterRequestPayload]);

  const fetchMore = () => {
    const props = getProps();
    dispatch(fetchPlansAsync(props));
    setPageNo(pageNo + 1);
  };

  const getInputDetails = (inputText: string) => {
    if (inputText.length > minSearchStrLength) {
      dispatch(
        setPageFilter({
          pageName: filterPage.libraryAllPlansSearchDisplay,
          modifiedFilter: filterRequestPayload
        })
      );
      dispatch(
        setPageFilter({
          pageName: filterPage.libraryAllPlansSearchIndividualActionsDisplay,
          modifiedFilter: filterRequestPayload.filter((item: any) => item.key !== "planType")
        })
      );
      navigate(`/library/search?q=${encodeURIComponent(inputText)}`, { state: { backURL: "/library" } });
    }
  };
  return (
    <div className="allPlans">
      <FunctionalAreasList />
      <Box
        display="flex"
        flexDirection={isMobileScreen ? "column" : "row"}
        justifyContent={"space-between"}
        gap={"16px"}
        alignItems={"center"}
      >
        <SearchAppBar
          sx={{ width: isMobileScreen ? "none" : "350px" }}
          placeholder="Search by plan name"
          isPreDefinedNav
          getInputDetails={getInputDetails}
          divider
          recentSearchWidth={isMobileScreen ? "none" : "350px"}
          libraryRecentSearch={libraryRecentSearch}
          setRecentSearch={setLibraryRecentSearch}
        ></SearchAppBar>
        <Box width={isMobileScreen ? "100%" : "inherit"}>
          {" "}
          <GlobalFilters page={filterPage.libraryAllPlansDisplay} />
        </Box>
      </Box>

      <GlobalFilterDescription page={filterPage.libraryAllPlansDisplay} bgColor={tokens.Background.General.Primary} />

      {showSuggested && (
        <SuggestedPlans
          showFocusAreas={true}
          filters={getSuggestedProps()}
          showNoSuggestedBanner={true}
          suggestedPlanIds={suggestedPlanIds}
        />
      )}

      {showAllPlans && (
        <div className="allPlans-plansList">
          <Typography
            showBold
            variant="h5"
            color={tokens.Text.General.Secondary}
            sx={{ marginTop: "-16px", marginBottom: "-8px" }}
          >
            All Plans
          </Typography>
          <Plans plansList={plansList} totalList={totalRecords} loadMore={fetchMore}></Plans>
        </div>
      )}
    </div>
  );
}

export default LibraryHall;
